import { useMemo } from 'react';
import { map } from 'lodash';
import { useTabs } from '../../../../Tabs/hooks/useTabs';
import { GoogleAssetsEntities } from '../../../../../constants';
import { useGoogleAssetsTextsStore } from 'stores/GoogleAssets/GoogleAssetsTextsStore';

const { IMAGES, Headlines, Descriptions, ShortHeadlines, LongHeadlines } = GoogleAssetsEntities;
const TABS_MAX_LENGTH = { [Descriptions]: 90, [Headlines]: 40, [ShortHeadlines]: 30, [LongHeadlines]: 90 };

export const useTextAssetsTab = () => {
  const { activeTabKey } = useTabs();
  const { tabAssets, setTabAssets } = useGoogleAssetsTextsStore();

  const placeholders = {
    headlines: 'Headline',
    descriptions: 'Description',
    shortHeadlines: 'Short Headline',
    longHeadlines: 'Long Headline'
  };

  const placeholder = useMemo(() => {
    if (activeTabKey === GoogleAssetsEntities.IMAGES) return;

    return placeholders[activeTabKey];
  }, [activeTabKey]);

  const handleChange = (text: string, id: string) => {
    if (activeTabKey === IMAGES) return;

    const updatedAssets = map(textAssets, (asset) => (id === asset.id ? { ...asset, text } : asset));
    setTabAssets({ ...tabAssets, [activeTabKey]: updatedAssets });
  };

  const textAssets = useMemo(() => {
    if (activeTabKey === IMAGES) return [];

    return tabAssets[activeTabKey];
  }, [activeTabKey, tabAssets]);

  const maxLength = useMemo(() => {
    if (activeTabKey === IMAGES) return;

    return TABS_MAX_LENGTH[activeTabKey];
  }, [activeTabKey]);

  return { placeholder, maxLength, textAssets, handleChange };
};
